"use client"
import React from "react";

import "@/components/categories/AmenityIcon.css";

const AmenityIcon = ({ amenity, size, stacked, className }) => {
  const theSize = size ?? "lg";
  if (amenity) {
    return (
      <div
        className={`amenity-icon-wrapper ${theSize} ${
          stacked ? "stacked" : "inline"
        } ${className ?? ""}`}
      >
        <div
          className={`amenity-icon ${theSize} ${
            stacked ? "stacked" : "inline"
          }`}
        >
          <i className={`fal ${amenity.icon}`}></i>
        </div>
        <span>{amenity.label}</span>
      </div>
    );
  } else {
    return <></>;
  }
};
export default AmenityIcon;
